export default __webpack_public_path__ + "static/contract-fcd75ab2d26ed5a5bd7111e3a17bf5d1.pdf";